<zef-dialog
  [open]="state.open"
  [autoFocus]="false"
  [options]="{ maxHeight: '80vh' }"
  (closeTrigger)="onClose$.next()">
  <div class="__content">

    <zui-form-section
      class="__form-section"
      separator="none">

      <span *zuiFormSectionTitle>
        {{ state.sensitive
          ? (state.readOnly
              ? state.projectEnvsEditDialogItemTranslations.titleDialogSecretReadOnly
              : state.projectEnvsEditDialogItemTranslations.titleDialogSecret)
          : (state.readOnly
              ? state.projectEnvsEditDialogItemTranslations.titleDialogReadOnly
              : state.projectEnvsEditDialogItemTranslations.titleDialog) }}
      </span>

      <z-project-envs-edit-form
        #formRef
        class="__form"
        (submit)="onUpdate$.next()"
        [state]="state.formState"
        [readOnly]="state.readOnly"
      />
    </zui-form-section>

    <div class="__buttons">
      <div class="__buttons-grid" [class.__buttons-grid--centered]="state.readOnly">

        @if (!state.readOnly) {
          <div>
            <zef-progress-error full [key]="updateKey">
              <button
                class="c-button--full"
                color="accent"
                mat-flat-button
                (click)="formRef.triggerSubmit()"
                type="button">
                {{ state.sensitive
                  ? state.projectEnvsEditDialogItemTranslations.titleActionButtonSecret
                  : state.projectEnvsEditDialogItemTranslations.titleActionButton }}
              </button>
            </zef-progress-error>
          </div>
        }

        <div>
          <button
            (click)="onClose$.next()"
            class="c-button--full"
            type="button"
            mat-button>
            <span transloco="general.close"></span>
          </button>
        </div>

      </div>
    </div>

  </div>
</zef-dialog>
